import GameState from "./game-state";
import DeadWaitState from "./dead-wait-state";

/**
 * First frag state - winner celebration animation in survivor mode
 * Shows corner border animation when player wins a round
 * Matches original Player_first_frag from player.cc
 */
export default class FirstFragState extends GameState {
  private couleur: number; // Color 8 (8<<4 = 128)
  private i: number; // Current x position (11-22)
  private j: number; // Current y position (4-9)
  private c: number; // Frame counter (for every-other-frame logic)

  enter(): void {
    this.canvas.dying = true;
    if (this.game.sendClientState) {
      this.game.sendClientState("waitForWinner");
    }
    
    // Clear all blinded blocks and set flash animation
    for (let j = 0; j < 36; j++) {
      for (let i = 0; i < 18; i++) {
        if (this.canvas.blinded[j][i]) {
          this.canvas.bflash[j][i] = 24;
          this.canvas.dirted[j][i] = 2;
        }
        this.canvas.blinded[j][i] = 0;
      }
    }

    // Initialize animation parameters
    this.couleur = 8 << 4; // Color 8 (128)
    this.i = 11;
    this.j = 4;
    this.c = 0;

    // Delete current block (matches original canvas->delete_bloc())
    // Note: set_next() is called in canvas, but we'll handle block clearing here
    this.canvas.bloc = null;

    // Increment round wins stat (if available)
    // Note: In original, this is canvas->stats[CS::ROUND_WINS].add(1)
    // We'll need to track this in game state or player stats
  }

  update(frameTime: number): void {
    super.update(frameTime);

    // Every other frame (matches original c++&1)
    this.c++;
    if (this.c & 1) {
      return;
    }

    if (this.j < 9) {
      // Place blocks at 4 corner positions
      // Top-left: [i][j]
      this.canvas.blocks[this.i][this.j] = 15 + this.couleur;
      this.canvas.occupied[this.i][this.j] = true;
      this.canvas.dirted[this.i][this.j] = 2;

      // Top-right: [42-i][j]
      this.canvas.blocks[42 - this.i][this.j] = 15 + this.couleur;
      this.canvas.occupied[42 - this.i][this.j] = true;
      this.canvas.dirted[42 - this.i][this.j] = 2;

      // Bottom-left: [i][17-j]
      this.canvas.blocks[this.i][17 - this.j] = 15 + this.couleur;
      this.canvas.occupied[this.i][17 - this.j] = true;
      this.canvas.dirted[this.i][17 - this.j] = 2;

      // Bottom-right: [42-i][17-j]
      this.canvas.blocks[42 - this.i][17 - this.j] = 15 + this.couleur;
      this.canvas.occupied[42 - this.i][17 - this.j] = true;
      this.canvas.dirted[42 - this.i][17 - this.j] = 2;

      this.i++;
      if (this.i === 22) {
        this.j++;
        this.i = 11;

        // Play sound effect when j increments
        // Original: play_sound(sons.flash, vo, 1000, 32500+ugs_random.rnd(1023))
        // Note: We'll need to implement sound playing if audio manager is available
        if (this.game.audioManager) {
          // Play flash sound with random pitch variation
          // TODO: Implement flash sound playback
          // const pitch = 32500 + Math.floor(Math.random() * 1023);
          // this.game.audioManager.playSound('flash', -600, 1000, pitch);
        }
      }
    } else {
      // Animation complete, transition to dead wait state
      this.canvas.dying = false;
      this.game.pushState(new DeadWaitState(this.game));
      this.game.popState(this);
    }
  }

  toString(): string {
    return "First Frag";
  }
}

